(() => {
  if (window.__zwickProductDetailsCleanupLoaded) return;
  window.__zwickProductDetailsCleanupLoaded = true;

  const meaningfulSelector = [
    'img[src]', 'video', 'iframe', 'canvas', 'model-viewer', 'svg:not(:empty)',
    'button', 'input', 'select', 'textarea', 'form', 'a[href]',
    '[role="button"]', '[role="dialog"]', '[data-product-option]'
  ].join(',');

  const isQuoteIntegration = (element) => {
    if (!element) return false;

    const identity = `${element.id || ''} ${typeof element.className === 'string' ? element.className : ''}`;
    if (/bss|bcp|quote|rfq/i.test(identity)) return true;

    return Boolean(element.querySelector(
      '[id*="bss" i], [class*="bss" i], [id*="bcp" i], [class*="bcp" i], [id*="quote" i], [class*="quote" i], [id*="rfq" i], [class*="rfq" i]'
    ));
  };

  const isMeaningful = (element) => {
    if (!element || element.hidden) return false;
    if (isQuoteIntegration(element)) return true;
    if (element.querySelector(meaningfulSelector)) return true;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, template, noscript')) return NodeFilter.FILTER_REJECT;
        return node.textContent?.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    return Boolean(walker.nextNode());
  };

  const getCandidates = (details) => {
    const candidates = new Set();

    details.querySelectorAll(':scope .group-block-content').forEach((content) => {
      Array.from(content.children).forEach((child) => {
        if (child.matches('script, style, template, noscript, .view-product-title')) return;
        candidates.add(child);
      });
    });

    details.querySelectorAll('.shopify-block, .shopify-app-block, [id^="shopify-block-"]').forEach((child) => {
      candidates.add(child);
    });

    return Array.from(candidates);
  };

  const evaluate = (details) => {
    if (details.dataset.hideEmptyBlocks !== 'true') return;

    getCandidates(details).forEach((candidate) => {
      candidate.classList.toggle('is-empty-product-details-block', !isMeaningful(candidate));
    });
  };

  const initialise = (details) => {
    if (details.dataset.emptyBlocksInitialised === 'true') return;
    details.dataset.emptyBlocksInitialised = 'true';

    let frame = null;
    const scheduleEvaluation = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        evaluate(details);
      });
    };

    const observer = new MutationObserver(scheduleEvaluation);
    observer.observe(details, { childList: true, subtree: true, characterData: true, attributes: true });

    scheduleEvaluation();
    setTimeout(scheduleEvaluation, 500);
    setTimeout(scheduleEvaluation, 1500);
    setTimeout(scheduleEvaluation, 3000);
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll?.('.product-details[data-hide-empty-blocks="true"]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
